import React, { useState, useEffect } from 'react';
import PersonalDashboardGcsp from '@components/templates/gcsp/dashboard/personalDashboardGcsp';
import YearlyMetricsGcsp from '@components/templates/gcsp/dashboard/yearlyMetricsGcsp';
import QuarterDetailsGcsp from '@components/templates/gcsp/dashboard/quarterlyDetailsGcsp';
import DashboardAlerts from '@components/organisms/alertBar/dashboardAlerts';
import SpinnerLoader from '@components/atoms/SpinnerLoader';
import DateTimePicker from '@components/atoms/datePicker/dateTimePicker';
import {
  DashboardWrapper,
  CenteredSpinner,
  DashboardContainer,
  DashboardTitles,
  QuarterlyMatrixTitle,
} from '@pages/dashboard/dashboard.styles';
import { PAGES, DASHBOARD_PAGE_TITLE } from '@constants/commonConstants';

const screenName = PAGES.DASHBOARD;

const GcspDashboard = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <DashboardWrapper>
      {loading ? (
        <CenteredSpinner>
          <SpinnerLoader color="#155CB4" />
        </CenteredSpinner>
      ) : null}
      <DashboardAlerts screenName={screenName} />
      <DashboardContainer>
        {!loading ? (
          <>
            <DashboardTitles>
              {DASHBOARD_PAGE_TITLE.MY_DASHBOARD}
              <DateTimePicker />
            </DashboardTitles>
            <PersonalDashboardGcsp />
            <QuarterlyMatrixTitle>{DASHBOARD_PAGE_TITLE.QUARTERLY_METRICS}</QuarterlyMatrixTitle>
            <QuarterDetailsGcsp />
            <QuarterlyMatrixTitle>{DASHBOARD_PAGE_TITLE.YEARLY_METRICS}</QuarterlyMatrixTitle>
            <YearlyMetricsGcsp />
          </>
        ) : null}
      </DashboardContainer>
    </DashboardWrapper>
  );
};

export default GcspDashboard;
